<template>
  <i
    :class="iconClass"
    :style="iconStyle"
  >
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13.092 17.395c.481-1.18 1.836-2.833 3.217-3.685l3.06 5.061-3.134 2.277-3.143-3.653Zm-4.518 3.647L4.26 18.268c3.265-6.103 9.367-10.45 16.538-11.26l1.201 3.7c-5.91 1.165-10.844 5.067-13.426 10.334Zm.94-12.562L10.06 2h3.874l.492 5.86c-2.223.762-3.53 1.371-5.028 2.292a15.922 15.922 0 0 0-3.01 2.382L2 10.682l1.196-3.69L9.515 8.48Z"/></svg>
    <!-- eslint-enable -->
  </i>
</template>

<script>
import BaseIcon from '../BaseIcon.vue';

export default {
  name: 'DpIconDocplanner',
  extends: BaseIcon,
  iconName: 'docplanner',
  iconCategory: 'logos',
};
</script>
